export const AIRESPRING_CRITERIA = {
  AIRESPRING: [
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Hardware Price Available?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The edge/license sizing by region provided in separate excel. 4 site sizes by the 3 regions, US, China, Global Non-China. ",
    },
    {
      Criteria: "Price",
      Model: "Outsourcing",
      Questions: "Price per site Tier Available?",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Price",
      Model: "Insourcing/Co-Managed",
      Questions: "Licensing (# users, bandwidth, length of time, fixed)",
      Check: "Yes",
      Rating: 2,
      Notes: "NA",
    },
    {
      Criteria: "Hardware Availability",
      Model: "All",
      Questions: "How available is the necessary hardware? (Lead times)",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How is path selection determined? (jitter, latency, packet loss)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Jitter, latency, packet loss – These metrics are used to monitor the performance of each available link. When the performance of a given path drops below acceptable thresholds, traffic is rerouted to a more reliable path.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path selection be dynamically configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud allows dynamic path selection, adjusting in real time based on link performance (latency, packet loss, jitter). This is part of the solution’s ability to continuously monitor and optimize traffic flow.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "What path selection options can be set?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Path selection can be based on several parameters, such as application priority, network conditions (latency, jitter, loss), or business rules. You can configure multiple path options depending on the application’s requirements.",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Can traffic be tagged based on rules?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, traffic can be tagged based on rules that you define for specific application types or priorities. This helps to manage different types of traffic more efficiently.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic be prioritized based on QOS or traffic tags?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, traffic can be prioritized based on QoS (Quality of Service) settings or specific traffic tags.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can path load sharing be configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud supports path load balancing, where traffic can be distributed across multiple WAN links to optimize performance and utilize available bandwidth.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can traffic steering be configured?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, traffic steering can be configured to route traffic based on policy-driven rules or application requirements.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution utilize traffic shaping to prioritize traffic for critical applications?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud utilizes traffic shaping to prioritize traffic for critical applications by managing bandwidth allocation according to application requirements.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution automatically select the best transport layer path based on performance metrics?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the system automatically selects the best transport layer path using performance metrics in real time, ensuring optimal application performance.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions: "Can the solution offer automated network failover?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, automatic network failover occurs when the primary link fails. Traffic is rerouted to secondary links with minimal disruption.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can the solution optimize access to popular SaaS applications?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud can optimize access to popular SaaS applications, with direct-to-cloud optimization and policies to ensure faster access and better performance.",
    },
    {
      Criteria: "Path Selection",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there AI features for path selection?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud leverages machine learning and AI to optimize network performance, making decisions based on historical data and real-time metrics for improved path selection.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Does solution detect and respond to a link-layer brownout? How?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, VeloCloud detects link-layer brownouts (temporary drops in link quality) and adjusts the routing to mitigate performance issues.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Can solution detect and respond to an application brownout? How? ",
      Check: "Yes",
      Rating: 2,
      Notes:
        "VeloCloud detects application brownouts, which are instances of degraded application performance, and reroutes traffic accordingly to maintain service quality.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe the system's link selection capabilities. Are they available per application?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "VeloCloud can select the best link per application, ensuring that mission-critical applications are routed through the optimal path based on real-time conditions.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution monitor application reachability across multiple links?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The system monitors application reachability across multiple links by testing and comparing metrics such as latency and packet loss.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "Describe how the solution handles end-user connections (TCP flows) when traffic has to be moved from one link to another. Are sessions terminated or maintained?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "When traffic is moved from one link to another, VeloCloud maintains TCP session persistence, so sessions are not terminated, ensuring minimal disruption for end users.",
    },
    {
      Criteria: "Path Selection",
      Model: "All",
      Questions:
        "How does the solution maintain flow symmetry and correct flows when asymmetry is detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud ensures flow symmetry when asymmetry is detected by using techniques to correctly match incoming and outgoing flows, maintaining application performance and consistency.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "Can the solution support all types of WAN transport layer connection types?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud supports multiple WAN transport types, including MPLS, broadband Internet (e.g., DSL, cable), LTE, and even 5G, enabling flexible connectivity options.",
    },
    {
      Criteria: "Transport Layer Connectivity",
      Model: "All",
      Questions:
        "All transport layer technologies are supported? Which ones are not?",
      Check: "Yes",
      Rating: 3,
      Notes: "VeloCloud supports most modern WAN transport types.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions: "Are Dynamic Protocols supported? Please list.",
      Check: "Yes",
      Rating: 2,
      Notes:
        "VeloCloud supports various dynamic routing protocols, including BGP (Border Gateway Protocol), OSPF (Open Shortest Path First), and RIP (Routing Information Protocol).",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "Does the solution operate without restrictions to any protocols?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "There are no significant protocol restrictions; however, it may be limited in highly specialized or legacy routing protocols.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there any routing best practices for the product? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Best practices include configuring the appropriate path selection rules for business-critical applications, maintaining redundancy, and fine-tuning routing policies to ensure optimal traffic steering.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Outsourcing",
      Questions:
        "Can the Client control routes at the edge in the MSP scenario?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Clients can control edge routes in a Managed Service Provider (MSP) scenario, allowing flexibility and better integration with existing network designs.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can the solution support multiple circuit carriers in active/active connection setup?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud supports multiple carriers in an active/active configuration, providing improved redundancy and bandwidth utilization.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Can routing be controlled at the edge?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Routing can be controlled at the edge, allowing more flexibility in how traffic is handled based on the SD-WAN policies.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does solution not require data-plane traffic to transit through single or multiple POPs (Point of Presence). Does solution operate without remote GW requirement?",
      Check: "Yes",
      Rating: 1,
      Notes:
        "VeloCloud requires the data plane traffic to pass through a VMware POP (Point of Presence). A remote gateway is typically required to manage the connection.",
    },
    {
      Criteria: "Routing Capabilities",
      Model: "All",
      Questions:
        "How does the solution integrate natively with existing MPLS WAN networks? Can the overlay and underlay be used simultaneously?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "VeloCloud can integrate natively with existing MPLS WAN networks, providing hybrid connectivity options. Both overlay and underlay networks can coexist.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions: "Does the solution offer redundancy options (specify)? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud provides redundancy with multiple WAN links, active-active link configurations, and automatic failover mechanisms to ensure high availability.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is there no requirement for additional equipment besides the redundant SD-WAN appliance?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud does not require additional specialized equipment other than the SD-WAN appliances or virtual instances deployed at the network edge.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Outsourcing",
      Questions: "What are failover and recovery speeds?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud provides near-instantaneous failover, typically within milliseconds, ensuring minimal disruption.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution include HA capabilities without requiring additional licensing? If not, please describe the licensing structure.",
      Check: "No",
      Rating: 1,
      Notes:
        "High Availability (HA) capabilities may require additional licenses depending on the configuration.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution work without WAN-side switches and/or unique ISP addresses?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Typically, VeloCloud does not require special ISP addresses or switches for operation. It uses the standard IP addressing provided by the ISPs.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support fail-to-wire interfaces (multi-networking failover interfaces)?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, VeloCloud supports fail-to-wire interfaces, ensuring that if SD-WAN functionality fails, the network can revert to a basic connectivity mode.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can and how does the solution operate when it is unable to communicate with its controller or orchestration function (if any)?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "If the solution cannot communicate with its controller, it can continue operating using the last known good configuration, with path selection and traffic management still functioning locally.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution support link capacity monitoring without flooding the link?",
      Check: "Yes",
      Rating: 1,
      Notes:
        "VeloCloud uses efficient monitoring mechanisms to track link performance without causing network congestion or flooding the link.",
    },
    {
      Criteria: "Resiliency & Failover",
      Model: "All",
      Questions:
        "Does the solution maintain 100% of the WAN capacity in the event of a unit failure?",
      Check: "Yes",
      Rating: 1,
      Notes:
        "VeloCloud ensures that the remaining operational links maintain the capacity necessary for essential traffic when a unit fails.",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions: "Are there no geographic deployment restrictions?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "VeloCloud has a broad geographic footprint but may face challenges in certain regions like China, where the internet infrastructure and regulations could impact performance.",
    },
    {
      Criteria: "Geographic Coverage",
      Model: "All",
      Questions:
        "What is the experience utilizing the solution in countries like China?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Deployment in countries like China may face restrictions and performance limitations due to local internet policies and infrastructure.",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Is solution documentation access available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud provides comprehensive documentation, including installation guides, user manuals, troubleshooting documentation, and online help, which is accessible via the VMware support portal.",
    },
    {
      Criteria: "Support",
      Model: "Insourcing",
      Questions: "Are training options available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VMware offers training programs for SD-WAN solutions through their VMware Education Services. These include both online courses and instructor-led sessions, catering to different levels of expertise.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer Zero Touch Provisioning?  If so, please describe the process.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud supports Zero Touch Provisioning. The process is simple and automated: devices are shipped to the site, powered on, and automatically connect to the VeloCloud Orchestrator for configuration without requiring onsite IT intervention.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If ZTP is offered, does it operate without special DNS/DHCP records?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "In ZTP, the devices use DHCP to get an IP address and DNS to resolve the Orchestrator's URL. No special DNS/DHCP records are required, but the devices must be able to access the internet for provisioning.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions:
        "Does the solution offer integration with Legacy Infrastructures?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud integrates well with legacy infrastructures, including MPLS networks, VPNs, and firewalls. It can be deployed as an overlay network on top of existing network infrastructure.",
    },
    {
      Criteria: "New Rollout",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there a templating feature? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud supports templating, allowing administrators to define configurations that can be applied across multiple devices/sites for streamlined deployment.",
    },
    {
      Criteria: "New Rollout",
      Model: "All",
      Questions: "How many hours does a new site turn-up normally take?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Typically, a new site turn-up takes a few hours, depending on network complexity and local configurations.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no node limitations or restrictions?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud does not have strict node limitations, but scaling depends on the size of the deployment and the performance capabilities of the devices used.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "Are there no tunnel limitations or bandwidth?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "There are no significant tunnel limitations, but bandwidth may be influenced by the underlying transport network.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there no limitations on logical WAN interfaces? If so, please describe ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud supports multiple logical WAN interfaces (e.g., MPLS, broadband, LTE) per device, with flexible path selection.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "No deployment architecture options and limitations? (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution supports various architectures beyond hub-and-spoke, including full-mesh and hybrid topologies.",
    },
    {
      Criteria: "Scalability",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution support hub and spoke VPN topologies? Are multiple hubs supported?  (little interest in hub & spoke)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution supports various architectures beyond hub-and-spoke, including full-mesh and hybrid topologies.",
    },
    {
      Criteria: "Scalability",
      Model: "Outsourcing",
      Questions:
        "If managed hardware solution, can the circuits be brought into existing hardware?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the SD-WAN Edge can support multiple circuits, which can be provided either by the customer or by AireSpring.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions:
        "Describe the steps for migrating a hybrid WAN (MPLS primary, Internet backup) solution into a SDWAN? Are there no disruptiions?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Migration from a hybrid WAN (MPLS and Internet) to SD-WAN is non-disruptive, as the SD-WAN solution can be deployed alongside MPLS and gradually replace or complement it.",
    },
    {
      Criteria: "Scalability",
      Model: "All",
      Questions: "No other scalability limitations?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution scales well for enterprise-grade deployments but may require additional hardware or licensing for very large deployments.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer a Single Pane of Glass?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud offers centralized management via the VeloCloud Orchestrator, providing a unified view of the entire network.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution allow management through the SSL portal? If yes does it support MFA and AD integration? SAML/SSO?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the solution supports management through a secure SSL portal. Multi-factor authentication (MFA) and integration with Active Directory (AD) for Single Sign-On (SSO) are supported.",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer performance visibility?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud provides detailed performance monitoring with visibility into key metrics like latency, jitter, packet loss, and throughput.",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the solution support Third-Party Application Integration?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the platform integrates with third-party systems like network monitoring tools and ITSM solutions.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Does solution not require an Engineer to Node?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "No, VeloCloud does not require engineers to physically access the nodes for management.",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions: "Does the solution offer API integration?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud provides a RESTful API, allowing full access to the solution's features.",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "Does the API provide access to 100% of the features and functions of the solution?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "We are currently using APIs for the initial onboarding of the Edge, which allows us to automate most of the configuration. Approximately 80% of the features can be configured via API.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Is the solution's management platform self-hosted, or vendor provided?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud’s management platform is vendor-provided and hosted on VMware’s cloud infrastructure (AWS/GCP/Azure), with no regional restrictions for most global deployments.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If vendor-provided, what underlying platform is being used (GCP/AWS/Azure/etc.)? What's the support model? Are there no regional limitations?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "We peer with Megaport from our POPs, providing access to the leading global cloud service providers via VXC. We ensure diverse fiber connectivity from our end to Megaport. This architecture is based on a POP and VXC model.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "If not vendor-provided, how is it deployed/managed? How does it scale?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "If not vendor-provided, the solution is typically deployed and managed by the customer using their on-premises or cloud infrastructure. Deployment involves configuring hardware or virtual SD-WAN appliances and integrating them with the existing network. We can scale adding additional resources such as hardware, virtual appliances, or circuits as needed. This can include increasing bandwidth, Tunnel License or deploying additional nodes",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Ease of Use? (new employee turn-up, vendor-specific terminology)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The solution is designed for ease of use, with a simple interface and minimal training required. Vendor-specific terminology is standard in the industry.",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Describe the upgrade process required to upgrade the solution?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Upgrades are automated and typically do not require manual intervention, making the process seamless, unless the edge devise does not support the higher bandwidth in the upgrade. ",
    },
    {
      Criteria: "Management",
      Model: "Insourcing/Co-Managed",
      Questions: "Are there generative AI capabilities for management?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Here are some of the key aspects of VeloCloud SD-WAN's AI management: \r\nAI algorithms analyze application performance and network conditions to route traffic through the most optimal path, ensuring the best possible user experience \r\nBased on AI insights, the network can automatically adjust configurations to address problems like congestion or link failures, minimizing downtime.\r\nThe system can identify and prioritize critical applications, ensuring they receive the necessary bandwidth and performance even during high traffic periods. \r\nVeloCloud automatically adjust routes based on real-time conditions, and proactively detect and apply FEC proactively",
    },
    {
      Criteria: "Management",
      Model: "All",
      Questions:
        "What is the licensing model for the solution? Please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The licensing model is subscription-based, with different tiers based on the number of sites, users, and throughput requirements.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the solution have an automation feature set?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud provides automation tools for monitoring, reporting, and troubleshooting network performance.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer integration with other troubleshooting projects?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "VeloCloud can integrate with other troubleshooting tools like network monitoring platforms for more comprehensive troubleshooting. Airespring also has their own set of tools to help with troubleshooting. ",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution support live packet capture for troubleshooting purposes?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the solution supports live packet capture, enabling administrators to capture and analyze traffic for troubleshooting.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions: "Does the management solution support inline ticket creation?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the platform supports inline ticket creation, which can be linked to specific performance issues for faster resolution. We have built our own portal, the AireControl Portal, where all services can be monitored, and you can manage your tickets directly. This AI-powered IT Service Management platform allows you to view the progress of existing orders as well. Additionally, 80% of our tickets are opened proactively by our AI Automation Engine and are automatically assigned for immediate action.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Can network administrator use the solution to troubleshoot an end-user specific reported application performance problem?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Administrators can use the Airespring VeloCloud Orchestrator to drill down into performance metrics, view live data, and initiate troubleshooting directly.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Are there any native testing tools available for troubleshooting? If so, what are they?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "VeloCloud offers built-in testing tools such as ping, traceroute, and flow analysis to help diagnose network issues.",
    },
    {
      Criteria: "Troubleshooting",
      Model: "All",
      Questions:
        "Does the solution offer Artificial Intelligence capabilities? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "The platform incorporates AI and machine learning to predict and identify network issues based on historical data and trends.",
    },
    {
      Criteria: "Technical Support",
      Model: "All",
      Questions:
        "Does the solution offer 24/7 technical support with defined service levels for response and resolution time? ",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, AireSpring provides 24/7 technical support with a defined escalation list, reaching up to the CEO level. Multiple communication channels are available to ensure prompt assistance for any issues or In case the initial response from our customer support team does not meet expectations. To add into this, AS Will assign a Tier3 Engineer that will be available within 10minutes of opening a case during business hours.",
    },
    {
      Criteria: "Technical Support",
      Model: "Insourcing/Co-Managed",
      Questions: "Is solution training available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "AireSpring will provide training for the end customer’s technical staff on how the configuration was deployed. Additionally, we will review the current VMware Orchestrator setup to ensure the customer fully understands the deployed infrastructure. Becoming an engineer requires substantial training and study, so we will recommend vendor-provided self-study resources for more advanced topics.",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions:
        "How long is an estimated MTTR of a defective gateway appliance (what are support options)?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "To mitigate the impact of a defective gateway appliance, AireSpring assigns three different gateways to each node by default. This ensures geo-redundant gateway access in case of a failure, minimizing downtime and enhancing reliability. As a result, the estimated MTTR is significantly reduced, as redundancy allows for seamless failover while the defective gateway is addressed.",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "What are the SLA support options available, list.",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Technical Support",
      Model: "Co-Managed/Outsourcing",
      Questions: "Are there financial implications for breaching SLA, explain?",
      Check: "No",
      Rating: 1,
      Notes: "No Info",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are reporting capabilities available? Describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VeloCloud can generate reports including all the data or configure them to include customized data. You can also create a recurring schedule to generate the reports during specified time.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "What types of data can be reported?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Edges by Application\r\nApplications by Traffic\r\nApplications by Transport\r\nBackup Link Usage\r\nTop Non SD-WAN Destinations (Direct)\r\nTop Non SD-WAN Destinations (via Airespring SD-WAN Gateway)\r\nTop Talkers",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can KPI data baselines be calculated automatically?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "We can track network performance, the baseline could be latency, packet loss, jitter or bandwidth usage over a month. Once the baseline is set, we should be able to compare it current performance. Thi all can be track via QoE and SDWNA enhancements",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there network-wide insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, network-wide insights are available. Our solution provides comprehensive visibility across the entire network/nodes, offering real-time data on performance, traffic patterns, device status, and more. Through advanced analytics and reporting tools, you can view metrics like bandwidth usage, latency, packet loss, and uptime across all locations and devices. These insights are presented in inside the dashboards, helping identify bottlenecks, optimize resources, and improve overall network efficiency. Additionally, the system offers historical data reports.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there site-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, site-level insights are available. Our solution provides detailed visibility into the performance and status of each individual site within the network. This includes different metrics such as bandwidth usage, latency, packet loss, device health, and application performance specific to each site. Site-level orchestrator allow for real-time monitoring and troubleshooting, helping to quickly identify issues or bottlenecks at a particular location. Additionally, historical data  are available for each site, enabling proactive management and optimization of site-specific resources.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there device-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, our Orchestrator provides detailed visibility into the performance and status of individual nodes in the network. This includes metrics such as device uptime, CPU and memory usage, interface statistics (e.g., bandwidth utilization, packet loss), and error rates. Additionally, real-time monitoring allows for proactive troubleshooting by alerting administrators to device-specific issues, such as hardware failures or connectivity problems",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Are there link-level performance metrics available?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, link-level performance metrics are available. Our solution provides comprehensive monitoring of network links, offering real-time data on key metrics such as bandwidth utilization, latency, jitter, packet loss, and link availability.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are there application-level insights available? If so, please describe.",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, application-level performance metrics are available. Our solution provides comprehensive monitoring of applications, offering real-time data on key metrics. This can be acomplish using QoE and Path Quality Scores",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are performance metrics available for sub-applications (e.g. Gmail vs. all Google apps)?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, Sub-applications policy can be build. We can build different performance metric for specific sub-application",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Are full performance monitoring capabilities available for traffic using direct-to-internet paths?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, full performance monitoring capabilities are available for traffic using direct-to-internet paths. Our solution provides comprehensive visibility into the performance of all traffic, including those using direct-to-internet paths.",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Are there end-user insights available? If so, please describe.",
      Check: "No",
      Rating: 1,
      Notes:
        "In this scenario, the end-user device will be the customer firewall. Our solution will hand off one interface to the customer firewall, and the customer will be able to request a specific block of public IPs. ",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions:
        "Can the data be reported in a visually appealing format? (Graphs, illustrations, etc.)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the visualization of different performance metrics throughout the entire orchestrator can be represented in various formats and can also be exported as PDF, CSV,  PNG charts and others",
    },
    {
      Criteria: "Reporting / Analytics",
      Model: "All",
      Questions: "Can data reporting be filtered by different time frames?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, as a standard, 3 months of data can be retrieved from the SD-WAN Orchestrator. Additionally, periodic automated reports can be generated.",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Is this solution application-aware?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN is application-aware. The solution provides deep visibility into application traffic and dynamically optimizes network performance based on real-time application needs. It uses application-level intelligence to identify, classify, and prioritize traffic, ensuring that critical applications receive the necessary bandwidth and low-latency treatment, while less critical traffic is deprioritized",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can traffic be dynamically steered based on real-time network performance and application priority?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN allows traffic to be dynamically steered based on real-time network performance and application priority. The solution continuously monitors network conditions, such as bandwidth, latency, jitter, and packet loss, and uses this information to make real-time decisions on how to route traffic. Critical applications, such as VoIP or video conferencing, can be prioritized and routed over the best-performing path, while less time-sensitive traffic can be directed over alternative paths. This dynamic steering ensures optimal application performance and enhances overall network efficiency, even in the face of changing network conditions or failures.",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application bandwidth be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN can detect application bandwidth usage. The solution provides deep visibility into application traffic, allowing it to monitor and measure the bandwidth consumption of individual applications in real-time. VMware SD-WAN can identify and classify applications, track their bandwidth usage, and provide detailed reports on their performance. This enables network administrators to ensure that critical applications receive the necessary bandwidth and optimize the overall network performance.",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application latency be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN can detect application latency. The solution continuously monitors the performance of application traffic across the network, including latency, jitter, and packet loss. By using real-time monitoring and advanced analytics, VMware SD-WAN can identify latency issues specific to individual applications. ",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application jitter be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN can detect application latency. The solution continuously monitors the performance of application traffic across the network, including latency, jitter, and packet loss. By using real-time monitoring and advanced analytics, VMware SD-WAN can identify latency issues specific to individual applications. ",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions: "Can application loss be detected?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN can detect application latency. The solution continuously monitors the performance of application traffic across the network, including latency, jitter, and packet loss. By using real-time monitoring and advanced analytics, VMware SD-WAN can identify latency issues specific to individual applications. ",
    },
    {
      Criteria: "App Aware",
      Model: "All",
      Questions:
        "Can the solution throttle at the application level (similar to application-based QoS policy)?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN allows for application-level traffic throttling, similar to application-based QoS policies. The solution enables administrators to set policies that control the bandwidth allocated to specific applications, ensuring that high-priority applications receive the necessary resources while less critical traffic can be throttled or deprioritized. This ensures optimal performance for mission-critical applications, such as VoIP or video conferencing, while managing overall network traffic efficiently. The flexibility to define these application-based QoE policies allows for better network resource management and improved user experience.",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Can policies be built based on tagged traffic?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer granular security policies?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Is there an application policy enforcement feature?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer monitoring and policy control based on user identity and user group membership?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Security Policy",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution incorporate DLP mechanisms?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Security Policy",
      Model: "All",
      Questions: "Does the solution allows login based on SSO?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Does the solution offer protection for the SD-WAN edge devices? If so, please describe.",
      Check: "Yes",
      Rating: 2,
      Notes:
        'Yes, we have configured these devices to ensure a minimal attack surface by separating the network device into three functional elements, referred to as "Planes": Management Plane, Control Plane, and Data Plane. Based on this architecture, we enforce a password policy (including length and complexity), enable 2FA, disable accounts that are no longer in use (this action is performed immediately), reset passwords periodically, and refrain from creating users when privilege requirements are unclear. We also restrict the number of super users, limit concurrent active sessions, restrict personnel who can access the orchestrator and edge devices, and restrict SSH or any direct access to the edge outside of the orchestrator.',
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "Describe how secret key material is protected throughout the entire provisioning and de-provisioning lifecycle?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "We assign a dedicated Implementation Engineer to oversee the entire project, ensuring that all restricted data is shared on a 1:1 basis. All customer data is securely stored within our own built-in Software, which has restricted access both outside the organization and between departments. Only authorized personnel with the appropriate clearance can access this tunnel. Devices that interact with this data are also protected within the AS domain and are governed by stringent security policies, including Data Loss Prevention (DLP). Throughout the provisioning and de-provisioning lifecycle, secret key material is protected by robust encryption protocols, restricted access controls, and continuous monitoring to prevent unauthorized access or leaks. We follow industry best practices to ensure that key material is securely handled at every stage, from generation to disposal.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "If a unit is lost or compromised, how is key information protected?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Direct Access to the edge is restricted and not available outside our organization, this are handle and configure in the cloud.",
    },
    {
      Criteria: "Secure Edge",
      Model: "All",
      Questions:
        "What mechanisms are in place to prevent a compromised unit from gaining network access?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "To prevent a compromised unit from gaining network access, we implement several layers of security mechanisms. These include:  Network Segmentation, Access Control and Monitoring, Key Material Protection and restricted access",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can source and destination Network Address Translation (NAT) be configured?  -(Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, this will depend on the Design to be implemented. NAT To the Internet is expected to be done on the customer firewal.",
    },
    {
      Criteria: "NAT",
      Model: "Insourcing/Co-Managed",
      Questions:
        "What types of NAT are supported?  (Presently NAT to be done on the FWs)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, this will depend on the Design to be implemented. NAT To the Internet is expected to be done on the customer firewal.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution meet U.S. encryption import/export guidelines and laws?",
      Check: "Yes",
      Rating: 3,
      Notes: "NA",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution use a single shared encryption key or multiple encryption keys between tunnels?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "The SDWAN Vmware edge use different Encryption Key between tunnels.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Are tunnel encryption keys rotated? How often are tunnel keys rotated?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, by default this is set to 480 Minutes to initiate a rekeying at the edge level. The low life time value for rekeying is suggested to be deploy only for debugging purposes.",
    },
    {
      Criteria: "Encryption/International Export Policies",
      Model: "All",
      Questions:
        "Does the solution support latest standard for end-to-end traffic encryption? (AES- 256)",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, this can be configure to use AES 256 as the AES Algorithms key size to encrypt Data",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution have stateful firewalling? ",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer Deep Packet Inspection?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions: "Does the solution offer an IDS & IPS feature?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Firewall Capabilities",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Does the solution offer antivirus and antimalware protection?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Can security rules be put in place for layer 4-7?",
      Check: "No",
      Rating: 1,
      Notes:
        "N/A, Firewall needs to be use behind the SDWAN Edge using Airespring Public IP",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions: "Are application/layer 7 rules supported?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, SDWAN Business policy can be defined based on the Application",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Can custom applications be defined based on URL or domain and subdomain? (E.g. example.com, crm.example.com)",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, SDWAN Business policy can be defined based on URL or domain and subdomain",
    },
    {
      Criteria: "Layer 4-7",
      Model: "Insourcing/Co-Managed",
      Questions:
        "Do custom applications receive 100% of the feature/functionality as built-in/system applications?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "Yes, custom applications receive 100% of the features and functionality available. VMware SDWAN Solution is designed to ensure that custom applications are treated with the same level of support, optimization, as any native applications. This includes access to network policies, traffic management and performance monitoring",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Does the solution have the ability to segment traffic?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, the solution allows for dividing the network into logical sub-networks, which can be used depending on the topology to be implemented. This is particularly useful if the network involves multiple organizations. In many cases, as part of our design, we use segmentation to backhaul specific traffic to designated nodes for different purposes.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Describe how traffic may be separated for different device types and pools?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "We use tags for segmentation, allowing specific VLANs, interfaces, QoE settings, and business policies to be assigned to a specific segment. This approach is similar to using VRFs, where each segment has its own routing table. These segments can be utilized for various purposes, such as Cardholder Data Environments, private networks, and regular traffic, ensuring isolation and optimized routing for each use case.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "When traffic separation is in place, is a different encryption key used for VPN tunnels?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "A different technique is used to keep traffic separate and avoid performance issues. This is achieved by using TAGs in the VCMP header, which allows for efficient traffic segmentation and management.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "Is the network segmentation capability PCI-compliant?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, All Vmware SDWAN Compounents meet PCI Requierments —including VMware SD-WAN Orchestrator,\r\nVMware SD-WAN Gateway, and VMware SD-WAN Edge",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions: "How does segmentation integrate with legacy Infrastructure?",
      Check: "Yes",
      Rating: 2,
      Notes:
        "We use tags for segmentation, allowing specific VLANs, interfaces, QoE settings, and business policies to be assigned to a specific segment. This approach is similar to using VRFs, where each segment has its own routing table. These segments can be utilized for various purposes, such as Cardholder Data Environments, private networks, and regular traffic, ensuring isolation and optimized routing for each use case.",
    },
    {
      Criteria: "Segmentation Capability",
      Model: "All",
      Questions:
        "Does SD-WAN solution capable to secure IoT devices? Is there a need for additional hardware to secure IoT?",
      Check: "No",
      Rating: 1,
      Notes: "VeloCloud SDWAN Edge is not going to be use as a firewall.",
    },
    {
      Criteria: "DDOS Protection",
      Model: "Co-Managed/Outsourcing",
      Questions: "How is DDOS Protection Supported/Achieved",
      Check: "Yes",
      Rating: 1,
      Notes:
        "DDoS is available in the USA only and is protecting Airespring IP's which can be delivered via SD-WAN which comes back to one of our datacenters which are BGP multi-homed to the Internet.  If an IP in our range gets DDoS'd then our routing metrics change to push our IP's to the DDoS Provider who takes the hit, blocks the bad traffic, and delivers the good to us.  Unlike other DDoS providers we have no time or traffic limit on this service.   Some attacks have lasted a LONG time and been as much as 5.6 terabits per second so it's a valuable service we're providing.",
    },
    {
      Criteria: "FIPS Compliant",
      Model: "All",
      Questions: "Is the device FIPS Compliant?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "Yes, VMware SD-WAN edges are validated against FIPS 140-2 standards, ensuring strong cryptographic algorithms for data protection.",
    },
    {
      Model: "All",
      Questions: "Are there any other Compliance Standards?",
      Check: "Yes",
      Rating: 3,
      Notes:
        "PCI Compliance, FIPS 140-2 Validation, certified against ISO 27001, 27017, and 27018 standards and Security Features",
    },
  ],
};
